import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { WarningAmber } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

const DeleteConfirmationModal = ({
  open,
  onClose,
  title = 'Confirmation',
  confirmationMessage,
  deleteButtonText,
  onDelete,
  isLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '.MuiDialog-paper': {
          width: '444px',
          boxShadow:
            '0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          borderBottom: '1px solid rgba(0, 37, 71, 0.12)',
        }}
      >
        <WarningAmber sx={{ color: 'rgba(211, 47, 47, 1)' }} />
        <div className='text-heading-style-1'>{title}</div>
      </DialogTitle>
      <DialogContent sx={{ padding: '20px 24px !important' }}>
        <div className='normal-text-style-2' style={{ lineHeight: '28px' }}>
          {confirmationMessage}
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button
          onClick={onClose}
          className='inherit-text-button-medium'
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={onDelete}
          className='error-contained-button-medium'
          endIcon={
            isLoading ? (
              <CircularProgress
                size={12}
                sx={{
                  '.MuiCircularProgress-svg': {
                    height: '12px',
                    width: '12px',
                    fontSize: '12px',
                    minWidth: '12px',
                  },
                }}
              />
            ) : null
          }
          disabled={isLoading}
        >
          {deleteButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
